import IntlText from '../../i18n/IntlText'

export default IntlText
